import { getShortcutsSelector } from 'core/store/customization/selectors';
import { useAppSelector } from 'core/store/store.utils';

import './shortcut-list.scss';

export const ShortcutList = () => {
  const { shortcuts: items } = useAppSelector(getShortcutsSelector);

  if (items.length === 0) return null;

  return (
    <div aria-label="Atajos" className="shortcut-list">
      {items.map((shortcut, idx) => (
        <a key={`${shortcut.redirectUrl}-${idx}`} href={shortcut.redirectUrl} target="_blank" rel="noreferrer">
          <img src={shortcut.imageUrl} alt={`Atajos para imagen ${idx + 1}`} className="shortcut-list__image" />
        </a>
      ))}
    </div>
  );
};
